<p-terminal
  #terminal
  [welcomeMessage]="getTerminalWelcomeMessage()"
  [prompt]="`${controller().serialNumber} $:`"
  (keydown)="onKeyDown($event)"
></p-terminal>
